
/* eslint-disable */

import Analytics from 'analytics'
import ltkPlugin from './Analytics_Plugin'
import tabEventsPlugin from 'analytics-plugin-tab-events'

let analytics;

if (typeof window.__PRERENDER_INJECTED === "undefined"){

  analytics = Analytics({
    app: 'ydr',
    debug: true,
    plugins: [
      tabEventsPlugin(),
      ltkPlugin('https://us-central1-custom-site-analytics.cloudfunctions.net/tracking_router_ydr',process.env.NODE_ENV),
    ]
  });

}

export default analytics;



// WEBPACK FOOTER //
// ./src/common/analytics.js